import { DatasetCondition } from '../../../../types/types';

type DatasetRow = Record<string, unknown>;

export const isDatasetConditionMet = (
  condition: DatasetCondition | undefined,
  currentRow: DatasetRow,
  masterRow?: DatasetRow | null
): boolean => {
  if (!condition) return true;

  const source = condition.source === 'masterRow' ? masterRow : currentRow;
  if (!source) return false;

  const value = source[condition.field];
  if (condition.in && !condition.in.includes(value)) return false;
  if ('equals' in condition && value !== condition.equals) return false;
  if ('notEquals' in condition && value === condition.notEquals) return false;
  return true;
};
